function hasTag(tags, tag) {
    return (tags === null || tags === void 0 ? void 0 : tags.some((x) => x.toLowerCase() === tag.toLowerCase())) || false;
}
export const isEventShouldShowScoreboards = (event) => {
    var _a, _b;
    return Boolean(hasTag(event === null || event === void 0 ? void 0 : event.tags, "LivePrePack") &&
        ((_b = (_a = event === null || event === void 0 ? void 0 : event.eventScorecard) === null || _a === void 0 ? void 0 : _a.scorecards) === null || _b === void 0 ? void 0 : _b.length));
};
//# sourceMappingURL=isEventShouldShowScoreboards.js.map